import React from 'react';
import Acl from "../../tools/Acl";
var AclContext = /*#__PURE__*/React.createContext(new Acl());
export default AclContext;